<template>
  <div>
    <div v-for="(speaker, index) in speakers" :key="index">
      <router-link :to="{ name: 'people', params: { id: speaker.id }, query: { reDirectFrom: 'link' }}">
        <span class="typo-color-blue">{{ speaker.full_name }}</span><span class="typo-color-black">,</span>
      </router-link>
      <span v-if="speaker.home_institution">{{ speaker.home_institution.name }}</span>
      <span v-else-if="speaker.institution">{{ speaker.institution }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpeakerSection',
  props: ['speakers'],
}
</script>
